import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';
import PaymentInfoReport from './PaymentInfoReport';
import IntegratedTransactionsIframe from './IntegratedTransactionsIframe';
import BatchSettlementReportIframe from './BatchSettlementReportIframe';
import CardSalesIframe from './CardSalesIframe';
import CardSalesDateIframe from './CardSalesByDateIframe';
import PayoutsIframe from './PayoutsIframe';
import PayoutByIdIframe from './PayoutByIdIframe';

const paths = {
  byPaymentId: '/reports/payment/:id',
  bySalePaymentId: '/reports/payment/retail/:salePaymentId',
  integratedTransactions: '/reports/payment/integrated-transactions',
  batchSettlementReport: '/reports/payment/settlements',
  cardSales: '/reports/payment/card-sales',
  cardSalesByDate: '/reports/payment/card-sales/:date',
  payouts: '/reports/payment/payouts',
  payoutById: '/reports/payment/payouts/:id',
};

export default [
  <RouteIfRights
    exact
    path={paths.integratedTransactions}
    key={paths.integratedTransactions}
    component={IntegratedTransactionsIframe}
    rights="reports"
  />,
  <RouteIfRights
    path={paths.batchSettlementReport}
    key={paths.batchSettlementReport}
    component={BatchSettlementReportIframe}
    rights="reports"
  />,
  <RouteIfRights
    exact
    path={paths.cardSales}
    key={paths.cardSales}
    component={CardSalesIframe}
    rights={['reports', 'reports_settlements']}
  />,
  <RouteIfRights
    path={paths.cardSalesByDate}
    key={paths.cardSalesByDate}
    component={CardSalesDateIframe}
    rights={['reports', 'reports_settlements']}
  />,
  <RouteIfRights
    exact
    path={paths.payouts}
    key={paths.payouts}
    component={PayoutsIframe}
    rights={['reports', 'reports_settlements']}
  />,
  <RouteIfRights
    path={paths.payoutById}
    key={paths.payoutById}
    component={PayoutByIdIframe}
    rights={['reports', 'reports_settlements']}
  />,
  <RouteIfRights
    exact
    path={paths.byPaymentId}
    key={paths.byPaymentId}
    component={PaymentInfoReport}
    rights="reports"
  />,
  <RouteIfRights
    path={paths.bySalePaymentId}
    key={paths.bySalePaymentId}
    component={PaymentInfoReport}
    rights="reports"
  />,
];

export { paths };
